export const NodeOperators = ['===', '!==', '>=', '<=', '>', '<', 'empty', 'notempty', 'anyof', 'contains'] as const;
export type NodeOperatorType = (typeof NodeOperators)[number];
export const operatorsWithNotNullValue: NodeOperatorType[] = ['===', '!==', '<=', '>=', '<', '>', 'anyof', 'contains'];

export const LogicalOperators = ['||', '&&'] as const;
export type LogicalOperatorType = (typeof LogicalOperators)[number];

export type ExpressionNodeType = {
  dataKey: string;
  value: any;
  operator: NodeOperatorType;
};

export type ExpressionTreeType = {
  operandOne: ExpressionTreeType | ExpressionNodeType;
  operandTwo: ExpressionTreeType | ExpressionNodeType;
  operator: LogicalOperatorType;
};

export type ExpressionType = ExpressionNodeType | ExpressionTreeType;

export type NodeEvalFunctionType = (answer: any, value?: any) => boolean;
export type TreeEvalFunctionType = (operandOne: boolean, operandTwo: boolean) => boolean;

export type ExpressionArrayType = {
  nodes: ExpressionNodeType[];
  operators: LogicalOperatorType[];
};
